import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { MultiSelect, MultiSelectProps } from '../../selects';
import { FranchiseType } from '../../../types';
import {
  reportFilterCountryCodeSelector,
  changeFranchiseTypeFilter,
  reportFranchiseTypeFilterSelector,
  reportFilterStoresSelector,
} from '../../../state';

type FranchiseTypeFilterProps = Pick<MultiSelectProps<string>, 'fullWidth' | 'disabled'>;

const FranchiseTypeFilter = (props: FranchiseTypeFilterProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const franchiseTypes = useSelector(reportFranchiseTypeFilterSelector);
  const options = Object.values(FranchiseType);
  const storesSelected = useSelector(reportFilterStoresSelector);
  const isStoresSelected = storesSelected.length > 0;

  const country = useSelector(reportFilterCountryCodeSelector);
  const isCountrySelected = country.length > 0;

  const isDisabled = !isCountrySelected || isStoresSelected;

  const handleChange = useCallback(
    (value: string[]) => dispatch(changeFranchiseTypeFilter(value as FranchiseType[])),
    [dispatch]
  );

  return (
    <MultiSelect<string>
      {...props}
      options={options}
      disabled={isDisabled || props?.disabled}
      value={franchiseTypes}
      translationKey="operativeStructure.franchiseType"
      label={t('operativeStructure.franchiseType.label')}
      onChange={handleChange}
      selectAll
    />
  );
};

export default FranchiseTypeFilter;
